// Phase A flip: /mascot-pick redirects to the new pal picker at
// /pal. Legacy MascotPickScreen.jsx goes dormant (deleted in Phase B).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/mascot-pick")({
  beforeLoad: () => {
    throw redirect({ to: "/pal" });
  },
  component: () => null,
});
